
var ele = $(".overlay-text");
var trackLength = 300;

ele.each(function() {
    var $this = $(this),
        currPosition = $this.position().left,
        current = $this.closest('section').scrollTop(),
        total = $this.closest('section').height() - current;


    $(window).on('scroll', function (e) {
        // scroll(total, $this, currPosition);
    });
});


function scroll(total, element, currPos) {
    current = element.closest('section').scrollTop();
    var newPosition = trackLength * (current/total);

    element.css({left:currPos+newPosition+'px'});
}